
import { useNavigate} from "react-router";

import './Logout.css';



function Logout() {
  let Navigate = useNavigate();
  const Logout = () =>{
    sessionStorage.removeItem("loggedin");
    sessionStorage.removeItem("username");

    console.log(sessionStorage)
            Navigate("/");
  }

 
  
   


      
      
     
return(

  <button onClick={Logout}>Logot</button>

)}

  export default Logout;